import { gql } from "@apollo/client";

export const GET_LINCENSES = gql`
  query GetLicenses {
    licenses {
      Id
      licensePeriod
    }
  }
`;
